// Estilo oscuro/ejecutivo consistente con el resto del PWA (paleta
// #0D0E10 / #1C1D20 / #2E2F33 / #C9A227 -- ver design_guidelines.json).
export const DARK_MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#0D0E10" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0D0E10" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#A0A0A5" }] },
  { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#2E2F33" }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#151719" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#1C1D20" }] },
  { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#2E2F33" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#A0A0A5" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2E2F33" }] },
  { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#C9A227" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#07080A" }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3B3D42" }] },
];

export const LIMA_CENTER = { lat: -12.0464, lng: -77.0428 };

export function createStyledMap(container, { center, zoom }) {
  return new window.google.maps.Map(container, {
    center,
    zoom,
    styles: DARK_MAP_STYLE,
    disableDefaultUI: true,
    zoomControl: true,
    clickableIcons: false,
  });
}
